/* Warehouse Gear Hub — home page behaviours.
   Plain script loaded with `defer` by sections/wgh-freight-estimator.liquid.
   Re-initialises whenever the theme editor re-renders a section.

   Freight estimator: mirrors the logic of the Claude Design mock. It never
   quotes a dollar figure — it returns the shipping MODE, the accessorial fees
   that will apply, and a transit window, all of which are merchant-editable
   text read from the section's JSON config block. */
(function () {
  'use strict';

  function initEstimator(root) {
    if (root.dataset.wghReady) return;
    root.dataset.wghReady = '1';

    var form = root.querySelector('[data-estimator-form]');
    var cfgEl = root.querySelector('[data-estimator-config]');
    if (!form || !cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }
    cfg.modes = cfg.modes || {};
    cfg.fees = cfg.fees || {};

    var zip = form.querySelector('[data-estimator-zip]');
    var item = form.querySelector('[data-estimator-item]');
    var submit = form.querySelector('[data-estimator-submit]');
    var result = form.querySelector('[data-estimator-result]');
    if (!zip || !item || !submit || !result) return;

    var state = { dock: null, commercial: null };

    form.querySelectorAll('[data-estimator-seg]').forEach(function (seg) {
      var key = seg.getAttribute('data-estimator-seg');
      var buttons = seg.querySelectorAll('button');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state[key] = btn.getAttribute('data-value') === 'true';
          buttons.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          validate();
          if (!result.hidden) render();
        });
      });
    });

    function validate() {
      var ok = /^\d{5}$/.test(zip.value.trim()) && state.dock !== null && state.commercial !== null;
      submit.disabled = !ok;
      return ok;
    }

    zip.addEventListener('input', function () {
      zip.value = zip.value.replace(/\D/g, '').slice(0, 5);
      validate();
    });
    item.addEventListener('change', function () {
      if (!result.hidden) render();
    });

    function iconFrom(selector) {
      var tpl = root.querySelector(selector);
      return tpl && tpl.content ? tpl.content.cloneNode(true) : document.createDocumentFragment();
    }

    function setText(selector, text) {
      var el = result.querySelector(selector);
      if (el) el.textContent = text || '';
    }

    function render() {
      var mode = cfg.modes[item.value] || cfg.modes.ltl || {};
      setText('[data-result-mode]', mode.name);
      setText('[data-result-note]', mode.note);
      var transit = mode.transit || '';
      if (transit && cfg.transitSuffix) transit += ' ' + cfg.transitSuffix;
      setText('[data-result-transit]', transit);

      var fees = [];
      if (item.value !== 'parcel') {
        if (!state.dock && cfg.fees.liftgate) fees.push({ fee: cfg.fees.liftgate });
        if (!state.commercial && cfg.fees.residential) fees.push({ fee: cfg.fees.residential });
        if (state.dock && state.commercial && cfg.fees.none) fees.push({ fee: cfg.fees.none, ok: true });
      }

      var wrap = result.querySelector('[data-result-fees-wrap]');
      var list = result.querySelector('[data-result-fees]');
      if (list) {
        list.textContent = '';
        fees.forEach(function (entry) {
          var row = document.createElement('div');
          row.className = 'wgh-estimator__fee' + (entry.ok ? ' wgh-estimator__fee--ok' : '');
          row.appendChild(iconFrom(entry.ok ? '[data-icon-ok]' : '[data-icon-warn]'));
          var text = document.createElement('div');
          var strong = document.createElement('strong');
          strong.textContent = entry.fee.label || '';
          text.appendChild(strong);
          if (entry.fee.why) {
            text.appendChild(document.createTextNode(' · '));
            var why = document.createElement('span');
            why.textContent = entry.fee.why;
            text.appendChild(why);
          }
          row.appendChild(text);
          list.appendChild(row);
        });
      }
      if (wrap) wrap.hidden = fees.length === 0;
      result.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (validate()) render();
    });
    validate();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wgh-estimator]').forEach(initEstimator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
